
import { Controller, useWatch } from "react-hook-form";
import Input from "../global/Input";
import RadioInput from "../global/RadioInput";
import DateInput from "../global/DateInput";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import ValidateError from "../global/ValidateError";
import { cn, getFormatedDate } from "../../utils/utils";

type Props = {
  control: any;
  errors: any;
  getValues: any;
  eventType:'new'|'edit'|'view'|'duplicate'
};

function MembershipInfo({ control, errors, getValues,eventType }: Props) {
  const { customers, inputs, shared, pricing }: DictionaryType =
    useGetDictionary();
  // watch trial value
  const enabledTrial = useWatch({
    control,
    name: "trial",
    defaultValue: true, // Provide a default value in case `Welcome_pack` is undefined
  });
  const start_date = useWatch({
    control,
    name: "start_date",
  });
   const enabledPack = useWatch({
    control,
    name: "Welcome_pack",
    defaultValue: true, // Provide a default value in case `Welcome_pack` is undefined
  });
  return (
    <div className="flex flex-col gap-8 w-full">
      <h3 className="font-bold text-lg text-primary dark:text-white ">
        {pricing.general_info}
      </h3>
      <div className="flex gap-8 flex-col w-full mobile:flex-wrap">
        <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 grid-rows-1  gap-2 mobile:min-w-[200px]">
          <div className="col-span-1 ">
            <Controller
              name="name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Input
                  label={inputs.name}
                  inputProps={{
                    ...field,
                    className:
                      "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                  }}
                  customClass={eventType === 'view'?'bg-[#f2f2f2]':''}
                />
              )}
            />
            {/* @ts-ignore */}
            {errors.name && <ValidateError />}
          </div>
           <div className="col-span-1 ">
            <Controller
              name="max_number_of_members"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Input
                  label={inputs.max_number_of_members}
                  inputProps={{
                    ...field,
                    className:
                      "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                    type: "number",
                    onWheel: (e) => {
                      e.preventDefault();
                      //@ts-ignore
                      e.target.blur();
                    },
                    step: 0,
                  }}
                  title={inputs.members}
                  customClass={eventType === 'view'?'bg-[#f2f2f2]':''}
                />
              )}
            />
            {/* @ts-ignore */}
            {errors.max_number_of_members && <ValidateError />}
          </div>
           <div className="col-span-2 flex flex-col">
            <label
              className=" mb-2 text-sm  text-primary dark:text-white flex"
              htmlFor="description"
            >
              {inputs.club_membership_description}
              <pre className="text-red-500">*</pre>
            </label>
            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <textarea
                  placeholder={inputs.description_in_bio}
                  readOnly={eventType === 'view'}
                  disabled={eventType == 'view'}
                  rows={1}
                  {...field}
                  className={cn("block w-full p-2  border h-full border-gray-300 rounded-md text-sm text-primary dark:text-white",eventType === 'view'?'bg-[#f2f2f2]':'')}
                />
              )}
            />
            {/* @ts-ignore */}
          </div>
          
        </div>
        <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 grid-rows-1 gap-2 mobile:min-w-[200px]">
            <div className="col-span-1">
            <Controller
              name="start_date"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <DateInput
                  placeHolder={pricing.start_date}
                  title={pricing.start_date}
                  isDisabled={eventType === 'view'}
                  min={getFormatedDate()}
                  name="start_date"
                  handleChangeEvent={field.onChange}
                  dateInputProps={{
                    ...field,

                    className:
                      "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                  }}
                />
              )}
            />
            {/* @ts-ignore */}
            {errors.start_date && <ValidateError />}
          </div>
         
          <div className="col-span-1">
            <Controller
              name="end_date"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <DateInput
                  placeHolder={pricing.end_date}
                  title={pricing.end_date}
                  name="end_date"
                  
                  isDisabled={eventType==='view'}
                  handleChangeEvent={field.onChange}
                  dateInputProps={{
                    ...field,
                    min: start_date
                      ? new Date(start_date).toLocaleDateString("sv-SE")
                      : "",
                    className:
                      "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                  }}
                />
              )}
            />
            {/* @ts-ignore */}
            {errors.end_date && <ValidateError />}
          </div>
        
        </div>
          <div className="flex-1 flex h-full items-center">
            <Controller
              name="state"
              control={control}
              render={({ field }) => (
                <div className="flex flex-row items-center gap-8">
                  <label className=" font-bold text-primary dark:text-white">
                    {inputs.status}
                  </label>
                  <RadioInput
                    value="admins_only"
                    name="state"
                    label={inputs.admins_only}
                    isDisabled={eventType === 'view'}
                    labelStyle="text-primary dark:text-white"
                    checked={
                      field.value === "admins_only" || field.value === false
                    }
                    onChange={field.onChange}
                  />
                  <RadioInput
                    value="on_app"
                     name="state"
                    label={inputs.app_also}
                    checked={field.value === "on_app" || field.value === true}
                    labelStyle="text-primary dark:text-white"
                    onChange={field.onChange}
                    isDisabled={eventType === 'view'}
                  />
                </div>
              )}
            />
          </div>
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 grid-rows-1 gap-4 ">
             <div className="flex-1 flex h-full items-center ">
            <Controller
              name="trial"
              control={control}
              render={({ field }) => (
                <div className="flex flex-row items-center gap-8">
                  <label className=" font-bold text-primary dark:text-white">
                    {customers.trial}
                  </label>
                  <RadioInput
                    value="true"
                    label={shared.yes}
                    labelStyle="text-primary dark:text-white"
                    isDisabled={eventType === 'view'}
                    checked={field.value.toString() === "true"}
                    onChange={(value) => {
                      return field.onChange(value === "true");
                    }}
                  />
                  <RadioInput
                    value="false"
                    label={shared.no}
                    labelStyle="text-primary dark:text-white"
                    isDisabled={eventType === 'view'}
                    checked={field.value.toString() === "false"}
                    onChange={(value) => {
                      return field.onChange(value === "true");
                    }}
                  />
                </div>
              )}
            />
          </div>
            {enabledTrial ? (
            <div className="col-span-1">
              <Controller
                name="trial_duration"
                control={control}
                rules={{
                  required: enabledTrial ? true : false,
                }}
                render={({ field }) => (
                  <Input
                    label={inputs.trial_duration}
                    inputProps={{
                      ...field,
                      className:
                        "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                      type: "number",
                      onWheel: (e) => {
                        e.preventDefault();
                        //@ts-ignore
                        e.target.blur();
                      },
                      step: 0,
                    }}
                    title={inputs.days}
                    customClass={eventType === 'view'?'bg-[#f2f2f2]':''}
                  />
                )}
              />
              {/* @ts-ignore */}
              {errors.trial_duration && <ValidateError />}
            </div>
          ) : (
            <div className="flex-1"></div>
          )}
          </div>
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 grid-rows-1 gap-4">
            <div className="col-span-1 flex h-full items-center">
                        <Controller
                          name="Welcome_pack"
                          control={control}
                          render={({ field }) => (
                            <div className="flex flex-row items-center gap-8">
                              <label className=" font-bold text-primary dark:text-white">
                                {inputs.welcome_pack}
                              </label>
                              <RadioInput
                                value="true"
                                label={shared.yes}
                                isDisabled={eventType === 'view'}
                                checked={field.value.toString() === "true"}
                                onChange={(value) => {
                                  return field.onChange(value === "true");
                                }}
                                labelStyle="text-primary dark:text-white"
                              />
                              <RadioInput
                                value="false"
                                label={shared.no}
                                isDisabled={eventType === 'view'}
                                labelStyle="text-primary dark:text-white"
                                checked={field.value.toString() === "false"}
                                onChange={(value) => {
                                  return field.onChange(value === "true");
                                }}
                              />
                            </div>
                          )}
                        />
                      </div>
                       <div className="col-span-1">
                                  {enabledPack ? (
                                    <>
                                      <Controller
                                        name="Welcome_pack_desc"
                                        control={control}
                                        rules={{
                                          required: enabledPack && shared.this_filed_is_required,
                                        }}
                                        render={({ field }) => (
                                          <Input
                                            label={inputs.welcome_pack_description}
                                            inputProps={{
                                              ...field,
                                              className:
                                                "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                                            }}
                                            customClass={eventType === 'view'?'bg-[#f2f2f2]':''}
                                          />
                                        )}
                                      />
                                      {/* @ts-ignore */}
                                      {errors.Welcome_pack_desc && <ValidateError />}
                                    </>
                                  ) : (
                                    <div className="flex-1"></div>
                                  )}
                                </div>
          </div>
         
      </div>
    </div>
  );
}

export default MembershipInfo;
/**
 * 
 *
 */